/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const IsraelSpecificHeader = ({ invoiceNumber, contactDetails }) => {
    const { RL_InvoiceNumber } = useSelector((state) => state);
    const customerName = contactDetails?.find(() => true)?.Name?.FullName || '';
    const customerId = contactDetails?.find(() => true)?.ID || '';

    return (
      <>
        <p>{invoiceNumber && `${RL_InvoiceNumber}:`}</p>
        <p>{invoiceNumber && invoiceNumber}</p>
        <br />
        <p>{customerName && `שם הלקוח: ${customerName}`}</p>
        <p>{customerId && `מזהה צרכן: ${customerId}`}</p>
        <br />
      </>
    );
};

IsraelSpecificHeader.defaultProps = {
    contactDetails: {},
    invoiceNumber: ''
};

IsraelSpecificHeader.propTypes = {
    contactDetails: PropTypes.arrayOf(PropTypes.shape()),
    invoiceNumber: PropTypes.string,
};

export default IsraelSpecificHeader;
